// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CohortSelect_wrapper","cohort":"CohortSelect_cohort","select":"CohortSelect_select","disabled":"CohortSelect_disabled"};